/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CustomerUpdatePhoneVariables = Types.Exact<{
  phoneToken: Types.Scalars['String']
  id: Types.Scalars['Int']
}>

export type CustomerUpdatePhone = {
  __typename: 'Root'
  customerUpdatePhone: {
    __typename: 'CustomerUpdatePhonePayload'
    customer: {
      __typename: 'Customer'
      id: number
      authenticationToken: string
      email: string
      completeProfile: boolean
      anonymous: boolean
      phone: any | null
    } | null
    errors: Array<{
      __typename: 'UserError'
      fullMessage: string | null
      key: string | null
      message: string | null
    }> | null
  } | null
}

export const CustomerUpdatePhoneDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CustomerUpdatePhone' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'phoneToken' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customerUpdatePhone' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phoneToken' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'phoneToken' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authenticationToken' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completeProfile' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'anonymous' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullMessage' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
export type CustomerUpdatePhoneMutationFn = Apollo.MutationFunction<
  CustomerUpdatePhone,
  CustomerUpdatePhoneVariables
>

/**
 * __useCustomerUpdatePhone__
 *
 * To run a mutation, you first call `useCustomerUpdatePhone` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerUpdatePhone` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerUpdatePhone, { data, loading, error }] = useCustomerUpdatePhone({
 *   variables: {
 *      phoneToken: // value for 'phoneToken'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerUpdatePhone(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CustomerUpdatePhone,
    CustomerUpdatePhoneVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CustomerUpdatePhone,
    CustomerUpdatePhoneVariables
  >(CustomerUpdatePhoneDocument, options)
}
export type CustomerUpdatePhoneHookResult = ReturnType<
  typeof useCustomerUpdatePhone
>
export type CustomerUpdatePhoneMutationResult =
  Apollo.MutationResult<CustomerUpdatePhone>
export type CustomerUpdatePhoneMutationOptions = Apollo.BaseMutationOptions<
  CustomerUpdatePhone,
  CustomerUpdatePhoneVariables
>
